// AUTOGENERATED - MANUALLY CHANGES WILL BE REVERTED BY THE GENERATOR
// https://polygonscan.com/address/0x1C2BA5b8ab8e795fF44387ba6d251fa65AD20b36
export const AAVE_POL_ETH_BRIDGE = '0x1C2BA5b8ab8e795fF44387ba6d251fa65AD20b36';

// https://polygonscan.com/address/0xEB0682d148e874553008730f0686ea89db7DA412
export const TRANSPARENT_PROXY_FACTORY = '0xEB0682d148e874553008730f0686ea89db7DA412';

// https://polygonscan.com/address/0xD3cF979e676265e4f6379749DECe4708B9A22476
export const PROXY_ADMIN = '0xD3cF979e676265e4f6379749DECe4708B9A22476';

// https://polygonscan.com/address/0x3b56998Ec06477704622ca8e2eA1b4db134cec32
export const CREATE_3_FACTORY = '0x3b56998Ec06477704622ca8e2eA1b4db134cec32';

// https://polygonscan.com/address/0xB4C212f5cD17E200019b07e6B1fDf124d35DBCf5
export const AAVE_CL_ROBOT_OPERATOR = '0xB4C212f5cD17E200019b07e6B1fDf124d35DBCf5';

// https://polygonscan.com/address/0xCb45E82419baeBCC9bA8b1e5c7858e48A3B26Ea6
export const PROTOCOL_GUARDIAN = '0xCb45E82419baeBCC9bA8b1e5c7858e48A3B26Ea6';

// https://polygonscan.com/address/0x7A9ff54A6eE4a21223036890bB8c4ea2D62c686b
export const AAVE_MERKLE_DISTRIBUTOR = '0x7A9ff54A6eE4a21223036890bB8c4ea2D62c686b';

// https://polygonscan.com/address/0x3Ea1eC855fBda8bA0396975eC260AD2e9B2Bc01c
export const wstETH_stETH_AGGREGATOR = '0x3Ea1eC855fBda8bA0396975eC260AD2e9B2Bc01c';

// https://polygonscan.com/address/0xeE652bbF72689AA59F0B8F981c9c90e2A8Af8d8f
export const MaticX_RATE_PROVIDER = '0xeE652bbF72689AA59F0B8F981c9c90e2A8Af8d8f';

// https://polygonscan.com/address/0xdEd6C522d803E35f65318a9a4d7333a22d582199
export const stMATIC_RATE_PROVIDER = '0xdEd6C522d803E35f65318a9a4d7333a22d582199';

// https://polygonscan.com/address/0xdc9A35B16DB4e126cFeDC41322b3a36454B1F772
export const LEGACY_BRIDGE_EXECUTOR = '0xdc9A35B16DB4e126cFeDC41322b3a36454B1F772';

// https://polygonscan.com/address/0x22740deBa78d5a0c24C58C740e3715ec29de1bFa
export const AFC_SAFE = '0x22740deBa78d5a0c24C58C740e3715ec29de1bFa';

// https://polygonscan.com/address/0xdef1FA4CEfe67365ba046a7C630D6B885298E210
export const MASIV_SAFE = '0xdef1FA4CEfe67365ba046a7C630D6B885298E210';

// https://polygonscan.com/address/0xa9e777D56C0Ad861f6a03967E080e767ad8D39b6
export const APE_VOTING_SAFE = '0xa9e777D56C0Ad861f6a03967E080e767ad8D39b6';

// https://polygonscan.com/address/0xF18F15362e5fB4277DCE713F170341942F43aC3E
export const REWARD_STEWARD = '0xF18F15362e5fB4277DCE713F170341942F43aC3E';

// https://polygonscan.com/address/0xd44342b1aC132353d3148Ea6ed330d1Ae6F0c664
export const AGENT_HUB = '0xd44342b1aC132353d3148Ea6ed330d1Ae6F0c664';

// https://polygonscan.com/address/0x125844D33F75090517Ea19Aab8Ca24eEa4Fef764
export const AGENT_HUB_AUTOMATION = '0x125844D33F75090517Ea19Aab8Ca24eEa4Fef764';

// https://polygonscan.com/address/0x9240a6669CC4782FC98620212862DF5CB2e0Df10
export const RANGE_VALIDATION_MODULE = '0x9240a6669CC4782FC98620212862DF5CB2e0Df10';

export const CHAIN_ID = 137;
